// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"42ddf515","189":"90e1628c"}[chunkId] + ".chunk.js";
};